// extracted by mini-css-extract-plugin
module.exports = {"list":"FriendsDisplay_tiles_list__3ZCeL","bg":"FriendsDisplay_tiles_bg__Sj68o"};